import React from 'react';
import useSiteMetadata from '../hooks/useSiteMetadata'

function ContactForm()
{
  const { siteURL } = useSiteMetadata()
  return (
    <div className="max-w-3xl px-6 py-8 mx-auto font-bold bg-darkerGrey contact">
      <form action="https://submit-form.com/yupr6aCB" data-botpoison-public-key="pk_c298584f-f09d-4513-9958-52236e6984e7">
        <div className="flex flex-col">
          <h3 className="my-2 text-xl font-semibold text-blue">Contact</h3>
          <input
            type="hidden"
            name="_redirect"
            value={`${siteURL}/contact-thanks`}
          />
          <input type="hidden" name="_error" value={`${siteURL}/contact`} />
          <div className="flex flex-col">

            <label htmlFor="opmerking">Opmerking</label>
            <textarea id="opmerking" name="opmerking" rows="11" className="resize-none" required />


            <label htmlFor="organisatie">Uw Organisatie</label>
            <input type="text" id="organisatie" name="organisatie" required />

            <label htmlFor="name">Uw Name</label>
            <input type="text" id="name" name="name" required />

            <label htmlFor="email">E-mailadres</label>
            <input type="email" id="email" name="email" required />

          </div>
          <button className="bg-green text-white w-fit py-1.5 px-5 my-6 text-lg font-light" type="submit">
            VERSTUREN
            </button>
        </div>
      </form>
    </div>
  );
}

export default ContactForm;